import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/Root'

import createHistory from 'history/createBrowserHistory'
import configureStore from './store/configureStore';
import {parse} from 'query-string';
import './scss/index.scss';

import moment from 'moment';
import 'moment/locale/lv';
moment.locale('lv',);

const history = createHistory();
const store = configureStore(history);

function addLocationQuery(history){
  history.location = Object.assign(
    history.location,
    {
      query: parse(history.location.search)
    }
  )
};

addLocationQuery(history);

history.listen(() => {
  addLocationQuery(history)
});



ReactDOM.render(
  <Root store={store} history={history} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js